/** The messages panel piece, standard look over its behavior half; the two share the stream's rest gate. */
import { useChatThreadGate } from '@/hooks/chat/useChatThreadScroll';
import type { PieceInput } from '../../contract/runtime';
import type { MessagesPanelEvents } from './contract';
import { MessagesPanelView } from './MessagesPanelView';
import { useMessagesPanelPiece } from './useMessagesPanelPiece';

export function MessagesPanel(props: PieceInput<MessagesPanelEvents>) {
  const gate = useChatThreadGate();
  return <MessagesPanelView {...useMessagesPanelPiece(gate, props)} gate={gate} />;
}
